<template>
  <div class="card shadow rounded-corner">
    <div class="card-body">
      <h5 class="card-title text-secondary fw-bold text-uppercase">Öffnungszeiten</h5>
      <p class="card-text">Wählen Sie die Tage und Zeiten, in denen ihre Lokalität geöffnet ist.</p>
      <div
        v-for="(businesshour, index) in localBusinesshours"
        :key="index"
        class="d-flex align-items-start gap-3 border-bottom pb-3 mb-3"
      >
        <div class="d-flex flex-wrap gap-3 flex-fill">
          <div class="d-flex gap-2 justify-content-between flex-fill">
            <div v-for="(day, dayindex) in weekdays" :key="dayindex" class="checkbox">
              <label class="d-flex flex-column align-items-center">
                {{ day }}
                <input
                  v-model="businesshour.days"
                  type="checkbox"
                  name="remember"
                  :value="dayindex"
                  @change="updateBusinesshours"
                />
                <div class="check" style="font-size: 140%"></div>
              </label>
            </div>
          </div>
          <div class="d-flex gap-3 flex-fill">
            <div class="form-floating flex-fill">
              <input
                v-model="businesshour.start"
                class="form-control"
                placeholder="von"
                type="time"
                style="min-width: 8.5rem"
                @change="updateBusinesshours"
              />
              <label>von</label>
            </div>
            <div class="form-floating flex-fill">
              <input
                v-model="businesshour.end"
                class="form-control"
                placeholder="bis"
                type="time"
                style="min-width: 8.5rem"
                @change="updateBusinesshours"
              />
              <label>bis</label>
            </div>
          </div>
          <div class="form-floating flex-fill">
            <input
              v-model="businesshour.text"
              placeholder="Freitext"
              class="form-control"
              type="text"
              style="min-width: 10rem"
              @change="updateBusinesshours"
            />
            <label>Freitext <small class="text-muted">(optional)</small></label>
          </div>
        </div>
        <button
          type="button"
          class="btn border text-muted hover:text-primary"
          style="padding: 0.375rem 1.25rem; height: calc(3.5rem + 2px)"
          @click="deleteBusinesshours(index)"
        >
          <i class="bi bi-trash-fill"></i>
        </button>
      </div>
      <button class="btn btn-secondary text-white" @click="addBusinesshours">weitere Öffnungszeit hinzufügen</button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, toRaw } from 'vue';

import remove from 'lodash/remove';
import clone from 'lodash/clone';

export default {
  props: {
    businesshours: {
      type: Object,
      default: null,
    },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const localBusinesshours = ref(props.businesshours);

    const weekdays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

    const dummy = {
      days: [],
      start: '',
      end: '',
      text: '',
    };

    onMounted(() => {
      if (localBusinesshours.value.length === 0) {
        addBusinesshours();
      }
    });

    const addBusinesshours = () => {
      localBusinesshours.value.push(clone(dummy));
    };

    const updateBusinesshours = () => {
      emit('update:data', { businesshours: toRaw(localBusinesshours) });
    };

    const deleteBusinesshours = (index) => {
      remove(localBusinesshours.value, (n, i) => i == index);
      updateBusinesshours();
    };

    return {
      localBusinesshours,
      addBusinesshours,
      updateBusinesshours,
      deleteBusinesshours,
      weekdays,
    };
  },
};
</script>

<style lang="scss" scoped></style>
